import { MdDelete } from "react-icons/md";
import { BiRename } from "react-icons/bi";
import { useTheme } from "../../../context/useThemeContext";
import { FaFolderOpen } from "react-icons/fa";
import useDataStore from "../../../stores/dataStore";
import { FaNoteSticky } from "react-icons/fa6";
import ContextMenuItem from "../ContextMenuItem";
import { ContextMenuSeparator } from "../ContextMenu";

export default function FolderContextMenu(props: {
    folderID?: string;
    renameFolder: () => void;
    openFolder: () => void;
    deleteFolder: () => void;
    addNote: () => void;
}) {
    const { theme } = useTheme();

    // Render
    return (
        <div>
            <ContextMenuItem
                label="Rename"
                disabled={!props.folderID}
                icon={<BiRename size={14} />}
                callbackFunction={() => {
                    props.renameFolder();
                }}
            />
            <ContextMenuItem
                label="Open"
                disabled={false}
                icon={<FaFolderOpen size={14} />}
                callbackFunction={() => {
                    props.openFolder();
                }}
            />
            <ContextMenuSeparator />
            <ContextMenuItem
                label="Add Note"
                disabled={false}
                icon={<FaNoteSticky size={14} />}
                callbackFunction={() => {
                    props.addNote();
                }}
            />
            <ContextMenuSeparator />
            <ContextMenuItem
                label="Delete"
                disabled={!props.folderID}
                icon={<MdDelete size={16} />}
                callbackFunction={() => {
                    props.deleteFolder();
                }}
            />
            {props.folderID && (
                <>
                    <ContextMenuSeparator />
                    <ColorSelector folderID={props.folderID} />
                </>
            )}
        </div>
    );
}

function ColorSelector(props: { folderID: string }) {
    const { theme } = useTheme();
    const folderColor =
        useDataStore.getState().data.folders[props.folderID]?.color;

    return (
        <div className="flex h-[26px] w-full min-w-[205px] items-center justify-between px-2">
            {theme.accentColors.map((color, index) => (
                <div
                    key={"noteColor_" + color}
                    className="h-[14px] w-[14px] cursor-pointer rounded-full"
                    style={{
                        backgroundColor: color,
                        border:
                            folderColor === index
                                ? "1px solid white"
                                : "transparent",
                    }}
                    onClick={() => {
                        useDataStore.getState().set.folder(props.folderID, {
                            color: index,
                        });
                    }}
                />
            ))}
        </div>
    );
}
